define("shared/components/shared/ui/icon-tooltip", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _exports.IconTooltipComponent = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <span ...attributes>
    <EmberTooltip @delay={{330}} @side={{or @side "top"}}>
      {{@tooltip}}
    </EmberTooltip>
    {{svg-jar (or @icon "help") class="o--icon"}}
  </span>
  */
  {
    "id": "ROH1FOo6",
    "block": "[[[11,1],[17,1],[12],[1,\"\\n  \"],[8,[39,0],null,[[\"@delay\",\"@side\"],[330,[28,[37,1],[[30,2],\"top\"],null]]],[[\"default\"],[[[[1,\"\\n    \"],[1,[30,3]],[1,\"\\n  \"]],[]]]]],[1,\"\\n  \"],[1,[28,[35,2],[[28,[37,1],[[30,4],\"help\"],null]],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n\"],[13]],[\"&attrs\",\"@side\",\"@tooltip\",\"@icon\"],false,[\"ember-tooltip\",\"or\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/ui/icon-tooltip.hbs",
    "isStrictMode": false
  });
  const IconTooltipComponent = _exports.IconTooltipComponent = (0, _templateOnly.default)();
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, IconTooltipComponent);
});